import { useNavigate, useParams } from "react-router";

import NotFoundPage from "@/app/NotFoundPage";
import { Loader } from "@/components/common/Loader";
import { useProvisionStock } from "@/features/provision-stocks/hooks/useProvisionStocks";
import StockDetailPage from "@/features/provision-stocks/ProvisionStockDetailPage";

export default function ProvisionStockDetailRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { stock, isLoading, error, refresh } = useProvisionStock(id);

  if (!id) {
    return <NotFoundPage />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-destructive">{error}</p>
        <button
          onClick={() => refresh()}
          className="mt-4 px-4 py-2 bg-foreground text-background rounded-lg hover:opacity-90 transition"
        >
          Réessayer
        </button>
      </div>
    );
  }

  if (!stock) {
    return <NotFoundPage />;
  }

  return <StockDetailPage stock={stock} onBack={() => navigate(-1)} />;
}
